export const createMultilevelSwitchStateDescription = (value: string): string => `greater than ${value}%`
